const toggleView = view => dispatch => {
  dispatch({
    type: "TOGGLE_VIEW",
    payload: view,
  });
};

export default toggleView;
